'use strict';
module.exports = require('./Button.vue');